export const numberFormatFilters = {
  filters: {
    toMoney: function (value) {
      if (!value) return ''
      if (value) {
        return Intl.NumberFormat('de-DE', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value)
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/numberFormatFilters.js